import { render, staticRenderFns } from "./ProjetoExtratoForm.vue?vue&type=template&id=e2354582&"
import script from "./ProjetoExtratoForm.vue?vue&type=script&lang=js&"
export * from "./ProjetoExtratoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports